import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome'
import LocalShippingIcon from '@mui/icons-material/LocalShipping'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'

export const PACE_ALLOCATION_CODE = '__AUTOMATED_ALLOCATION_PACE'

// PACE is the only automated allocation entry. Legacy rule codes
// (__AUTOMATED_ALLOCATION_PERFORMANCE / _COST / _BALANCED / _WEIGHTED) are
// still honoured by the backend and are treated as PACE.
export const AUTO_ALLOCATION_OPTIONS = [
  {
    value: PACE_ALLOCATION_CODE,
    label: 'PACE',
    icon: <AutoAwesomeIcon />,
    description: "PACE ranks the couriers using the merchant's Business Knobs",
    color: '#1565c0',
  },
]

// Map any stored automated-allocation code (legacy or current) to the PACE code.
export const normalizeAutoAllocation = (code) =>
  !code || String(code).startsWith('__AUTOMATED_ALLOCATION_') ? PACE_ALLOCATION_CODE : code

export const DELIVERY_TYPES = [
  {value: 'FORWARD', label: 'Forward', icon: <LocalShippingIcon />},
  {value: 'RVP', label: 'Reverse', icon: <ContentCopyIcon />},
]

export const DISPATCH_MODES = ['Surface', 'Air']
export const PAYMENT_MODES = ['COD', 'Prepaid']
export const QC_TYPES = ['QC', 'Non-QC']
export const ZONES = ['All', 'Local', 'ROI', 'Regional', 'Metros', 'Special']
export const SHIPMENT_TYPES = ['B2B', 'B2C']

export const getBaseRules = () => [
  {
    id: 1,
    name: 'Forward / B2C / COD',
    deliveryType: 'FORWARD',
    dispatchMode: '',
    paymentMode: 'COD',
    autoAllocation: PACE_ALLOCATION_CODE,
    fallbackCouriers: [],
    courierAccounts: [],
    isDefault: true,
    shipmentType: 'B2C',
    servicablePickupPincodes: 'ALL',
    servicableDropPincodes: 'ALL',
    advancedSettings: {
      zone: '',
      minWeight: '',
      maxWeight: '',
      minInvoice: '',
      maxInvoice: '',
      pickupPincode: [],
      dropPincode: [],
      channel: [],
      rvpReason: '',
      itemUnits: '',
      uniqueSkuCount: '',
    },
    priority: 1,
  },
  {
    id: 2,
    name: 'Forward / B2C / Prepaid',
    deliveryType: 'FORWARD',
    dispatchMode: '',
    paymentMode: 'Prepaid',
    autoAllocation: PACE_ALLOCATION_CODE,
    fallbackCouriers: [],
    courierAccounts: [],
    isDefault: true,
    shipmentType: 'B2C',
    servicablePickupPincodes: 'ALL',
    servicableDropPincodes: 'ALL',
    advancedSettings: {
      zone: '',
      minWeight: '',
      maxWeight: '',
      minInvoice: '',
      maxInvoice: '',
      pickupPincode: [],
      dropPincode: [],
      channel: [],
      rvpReason: '',
      itemUnits: '',
      uniqueSkuCount: '',
    },
    priority: 2,
  },

  {
    id: 3,
    name: 'Forward / B2B / COD',
    deliveryType: 'FORWARD',
    dispatchMode: '',
    paymentMode: 'COD',
    autoAllocation: PACE_ALLOCATION_CODE,
    fallbackCouriers: [],
    courierAccounts: [],
    isDefault: true,
    shipmentType: 'B2B',
    servicablePickupPincodes: 'ALL',
    servicableDropPincodes: 'ALL',
    advancedSettings: {
      zone: '',
      minWeight: '',
      maxWeight: '',
      minInvoice: '',
      maxInvoice: '',
      pickupPincode: [],
      dropPincode: [],
      channel: [],
      rvpReason: '',
      itemUnits: '',
      uniqueSkuCount: '',
    },
    priority: 3,
  },
  {
    id: 4,
    name: 'Forward / B2B / Prepaid',
    deliveryType: 'FORWARD',
    dispatchMode: '',
    paymentMode: 'Prepaid',
    autoAllocation: PACE_ALLOCATION_CODE,
    fallbackCouriers: [],
    courierAccounts: [],
    isDefault: true,
    shipmentType: 'B2B',
    servicablePickupPincodes: 'ALL',
    servicableDropPincodes: 'ALL',
    advancedSettings: {
      zone: '',
      minWeight: '',
      maxWeight: '',
      minInvoice: '',
      maxInvoice: '',
      pickupPincode: [],
      dropPincode: [],
      channel: [],
      rvpReason: '',
      itemUnits: '',
      uniqueSkuCount: '',
    },
    priority: 4,
  },

  {
    id: 5,
    name: 'Reverse / B2C / QC',
    deliveryType: 'RVP',
    dispatchMode: '',
    qcType: 'QC',
    autoAllocation: PACE_ALLOCATION_CODE,
    fallbackCouriers: [],
    courierAccounts: [],
    isDefault: true,
    shipmentType: 'B2C',
    servicablePickupPincodes: 'ALL',
    servicableDropPincodes: 'ALL',
    advancedSettings: {
      zone: '',
      minWeight: '',
      maxWeight: '',
      minInvoice: '',
      maxInvoice: '',
      pickupPincode: [],
      dropPincode: [],
      channel: [],
      rvpReason: '',
      itemUnits: '',
      uniqueSkuCount: '',
    },
    priority: 5,
  },
  {
    id: 6,
    name: 'Reverse / B2C / Non-QC',
    deliveryType: 'RVP',
    dispatchMode: '',
    qcType: 'Non-QC',
    autoAllocation: PACE_ALLOCATION_CODE,
    fallbackCouriers: [],
    courierAccounts: [],
    isDefault: true,
    shipmentType: 'B2C',
    servicablePickupPincodes: 'ALL',
    servicableDropPincodes: 'ALL',
    advancedSettings: {
      zone: '',
      minWeight: '',
      maxWeight: '',
      minInvoice: '',
      maxInvoice: '',
      pickupPincode: [],
      dropPincode: [],
      channel: [],
      rvpReason: '',
      itemUnits: '',
      uniqueSkuCount: '',
    },
    priority: 6,
  },
]
